import { Fragment } from 'react';
import { HpSharedLocationsModule } from './HpSharedLocationsModule/HpSharedLocationsModule';
import HpSharedPromoModule from './HpSharedPromoModule/HpSharedPromoModule';
import HpSharedCollectionsModule from './HpSharedCollectionsModule/HpSharedCollectionsModule';
import { HpSharedShopByModule } from './HpSharedShopByModule/HpSharedShopByModule';
import { HpSharedTopHeroBannerModule } from './HpSharedTopHeroBannerModule/HpSharedTopHeroBannerModule';
import { HpSharedEditorialModule } from './HpSharedEditorialModule/HpSharedEditorialModule';
import { HpSharedFeaturedBannerModule } from './HpSharedFeaturedBannerModule/HpSharedFeaturedBannerModule';
import HpSharedVideoComponent from './HpSharedVideoComponent/HpSharedVideoComponent';

import { type HpSharedLayout_viewer$data } from './__generated__/HpSharedLayout_viewer.graphql';

type Homepage = NonNullable<HpSharedLayout_viewer$data['homepage']>;
type User = HpSharedLayout_viewer$data['user'];
type HomepageModules = NonNullable<NonNullable<Homepage['modules']>[0]>;

type Props = {
    componentModule: HomepageModules;
    key: string;
    startingPromoIndex: number;
    viewer: HpSharedLayout_viewer$data;
    isMobile: boolean;
    useLazyLoadImages: boolean;
    moduleIndex: number;
    totalModules: number;
    user?: User;
    isClient: boolean;
};

export const componentModuleMap: Record<string, (payload: Props) => JSX.Element | null> = {
    topHeroBanner: ({ key, componentModule, isMobile }) => (
        <HpSharedTopHeroBannerModule
            key={key}
            componentModule={componentModule}
            isMobile={isMobile}
        />
    ),
    collections: ({ componentModule, key, useLazyLoadImages, moduleIndex, totalModules }) => (
        <HpSharedCollectionsModule
            key={key}
            componentModule={componentModule}
            useLazyLoadImages={useLazyLoadImages}
            moduleIndex={moduleIndex}
            totalModules={totalModules}
        />
    ),
    promo: ({
        componentModule,
        startingPromoIndex,
        key,
        useLazyLoadImages,
        isMobile,
        moduleIndex,
        totalModules,
    }) => (
        <HpSharedPromoModule
            key={key}
            componentModule={componentModule}
            startingPromoIndex={startingPromoIndex}
            useLazyLoadImages={useLazyLoadImages}
            isMobile={isMobile}
            moduleIndex={moduleIndex}
            totalModules={totalModules}
        />
    ),
    editorial: ({ key, componentModule, isMobile }) => (
        <HpSharedEditorialModule key={key} componentModule={componentModule} isMobile={isMobile} />
    ),
    shopBy: ({
        viewer,
        componentModule,
        key,
        useLazyLoadImages,
        moduleIndex,
        totalModules,
        isClient,
    }) => (
        <HpSharedShopByModule
            key={key}
            viewer={viewer}
            componentModule={componentModule}
            useLazyLoadImages={useLazyLoadImages}
            moduleIndex={moduleIndex}
            totalModules={totalModules}
            isClient={isClient}
        />
    ),
    locations: ({ key, isMobile, user, viewer, isClient }) => (
        <Fragment key={key}>
            <HpSharedLocationsModule
                isMobile={isMobile}
                viewer={isClient ? viewer : null}
                user={user}
            />
            <HpSharedFeaturedBannerModule isMobile={isMobile} />
        </Fragment>
    ),
    video: ({ key, componentModule, user, isClient }) =>
        isClient ? (
            <HpSharedVideoComponent
                key={key}
                user={user}
                fetchFavorites={false}
                componentModule={componentModule}
            />
        ) : null,
};
